














































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios from "axios";

@Component
export default class DocumentForm extends Vue {
  // @Prop() document!: {};

  formData: any = {};
  isSubmitting: boolean = false;
  submitResult: boolean = false;
  isSubmitted: boolean = false;
  spatialOptions: [] = [];
  documentTypes: [] = [];
  frequency: [] = [];
  correctionTypes: [] = [];
  isNew = true;
  source: any = {};
  isCorrection = false;

  async mounted() {
    this.spatialOptions = (
      await axios.get<[]>("/lookup/spatial-coverage", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.documentTypes = (
      await axios.get<[]>("/lookup/document-type", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.frequency = (
      await axios.get<[]>("/lookup/frequency", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
    this.correctionTypes = (
      await axios.get<[]>("/lookup/correction-type", {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      })
    ).data;
  }

  async submit() {
    if (this.isSubmitted) return;
    this.isSubmitting = true;
    try {
      await axios.post("/document", this.formData, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      });
      this.isSubmitted = true;
      this.submitResult = true;
    } catch {
      this.isSubmitted = true;
      this.submitResult = false;
    }
  }

  GoBack() {
    this.$router.go(-1);
  }

  @Watch("$route", { immediate: true })
  async watchRoute(document: any) {
    let source = this.$route.params.source;

    this.isNew = source.indexOf(".") !== -1;

    if (this.isNew) {
      var res = await axios.get(`/cat/v2/${source}`, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      });
      this.source = res.data;
      this.formData = {
        node_id: this.source.node_id,
        name: this.source.name,
      };
    } else {
      var doc = await axios.get(`/document/${source}`, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      });
      console.log(doc.data);
      var plannedDate = new Date(doc.data.planned_publishing_date);
      var dueDate = new Date(doc.data.due_date);
      this.formData = doc.data;
      this.formData.planned_publishing_date = plannedDate;
      this.formData.due_date = dueDate;
      var node = await axios.get(`/cat/v2/${this.formData.node_id}`, {
        headers: {
          Authorization: "Bearer " + localStorage.token,
        },
      });
      //this.formData.name = node.data.name;
    }
  }

  // @Watch("document", { immediate: true })
  // async watchDocument(document: any) {
  //   this.isSubmitting = this.isSubmitted = this.submitResult = false;

  //   if (document) {
  //     // document.spatial_coverage_id = parseInt(document.spatial_coverage_id);
  //     console.log(document.spatial_coverage_id, "spat");
  //     document.planned_publishing_date = new Date(
  //       document.planned_publishing_date
  //     );
  //     document.due_date = new Date(document.due_date);
  //     this.formData = document;
  //   }
  // }
}
